<div
  class="grid justify-center w-full grid-cols-1"
  [ngClass]="bigVersion() ? 'gap-4.5 pb-8 pt-6 md:grid-cols-2 md:pt-5' : 'grid-cols-2 gap-4'"
>
  <a
    [href]="enabled() ? SOCIAL_LOGIN_GOOGLE : null"
    [class.opacity-50]="!enabled()"
    [class.pointer-events-none]="!enabled()"
  >
    <enx-shared-ui-social-login-chip
      icon="assets/images/google.svg"
      [id]="googleId()"
      [label]="'common.social.google' + suffixLabel() | translate"
    ></enx-shared-ui-social-login-chip>
  </a>
  <a
    [href]="enabled() ? SOCIAL_LOGIN_APPLE : null"
    [class.opacity-50]="!enabled()"
    [class.pointer-events-none]="!enabled()"
  >
    <enx-shared-ui-social-login-chip
      icon="assets/images/apple.svg"
      [id]="appleId()"
      [label]="'common.social.apple' + suffixLabel() | translate"
    ></enx-shared-ui-social-login-chip>
  </a>
</div>
